export default {
  data() {
    return {
      isConfirm: true,
      leaveView: null,
      nextPath: '',
      opacity: 100,
    };
  },
  methods: {
    openModal(isConfirm) {
      this.isConfirm = isConfirm;
      this.$bvModal.show('modal-client');
    },
    toBackClientView() {
      this.$router.push('/clientes');
    },
    confirmLeaveView() {
      this.leaveView = true;
      this.$router.push(this.nextPath);
    },
    updateOpacity() {
      let opacityValue = 0;

      if (this.clientData)
        opacityValue =
          (parseInt(this.clientData.city.color.slice(-2), 16) / 255) * 100;
      else opacityValue = (parseInt(this.color.slice(-2), 16) / 255) * 100;

      this.opacity = Math.round(opacityValue);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.leaveView) {
      next();
    } else {
      this.$bvModal.show('modal-leave-view');
      this.nextPath = to.path;
    }
  },
  mounted() {
    this.leaveView = false;
  },
};
